export const enum Constants {
    GAME = "game",
    GAMES = "games",
    VERSIONS = "versions",
    BUILD_PREFIX = "buildPrefix",
    BUILD_PREFIXES = "buildPrefixes",
    EXCLUSIVE_GAMES = "exclusive-games",
    NON_EXCLUSIVE_GAMES = "non-exclusive-games",
    PROTOTYPES = "prototypes",
    ENVIRONMENTS = "environments",
    INTEGRATIONS = "integrations",
    LANGUAGES = "languages",
    CURRENCIES = "currencies",
    PLAY_MODES = "playModes",
    ID = "id",
    TAG = "tag",
    SEQUENCE = "sequence",
    SERVER_ADDRESS = "serverAddress",
    CLIENT_ADDRESS = "clientAddress",
    SERVER_PATH = "serverPath",
    CLIENT_PATH = "clientPath",
    FORCE_LOCAL = "forceLocal",
    DEFAULT_PARAMS = "defaultParams",
    DEFAULT_CURRENCY = "defaultCurrency",
    SERVER_PORT = "serverPort",
    OPERATORS = "operators",
    BRANDS = "brands",
    NAME = "name",
    IMAGE_NAME = "imageName",
    CONFIG_PATH = "configPath",
    CONFIGS = "configs",
    GAME_ID_PREFIX = "gameIdPrefix",
    OUTCOMES = "outcomes",
    PLAYER_ID = "playerId",
    AWS_URL = "https://estonia-interactive.s3.eu-north-1.amazonaws.com",
    OCTOPUS_API_URL = "https://octopus.ksgwebgames.com/api",
}
